export let Country = /*#__PURE__*/function (Country) {
  Country["AUSTRALIA"] = "Australia";
  Country["NEW_ZEALAND"] = "New Zealand";
  return Country;
}({});